import { render, staticRenderFns } from "./SectionCost.vue?vue&type=template&id=538252c8&scoped=true&"
import script from "./SectionCost.vue?vue&type=script&lang=js&"
export * from "./SectionCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538252c8",
  null
  
)

export default component.exports